import PropTypes from "prop-types";
import WebIcon from "@/components/common/Web_Icons";
import Avatar from "@/components/common/Avatar";
import ActionButtons from "@/pages/user_management/components/single_user/Action_Buttons";
import Apc from "@/assets/images/apc.png";

const UserProfileHeader = ({ user, onDelete, onModify }) => {
  return (
    <div className="flex flex-col items-start justify-between gap-4 bg-white lg:flex-row  rounded-lg lg:p-3">
      <div className="flex flex-col items-center gap-4 lg:flex-row">
        <div className="lg:w-[194px] lg:h-[156px] w-full max-w-[500px]">
          <Avatar
            src={user.avatar}
            alt={user.name}
            size="full"
            shape="rounded"
            className="!w-full !h-full !aspect-auto !rounded-lg"
          />
        </div>

        <div>
          <h1 className="mb-1 text-2xl font-bold text-left lg:text-4xl text-primary">
            {user.name}
          </h1>
          <div className="flex items-center gap-2">
            <p className="text-small text-lighterGrey">
              {user.role || "No Role"}
            </p>
            {user.party && (
              <>
                <div className="bg-primary rounded-full w-[3px] h-[3px]"></div>
                <img src={Apc} alt="party" className="w-3 h-3" />
                <span className="text-small text-primary">{user.party}</span>
              </>
            )}
          </div>
          <div className="flex items-center gap-4 mt-2 text-lg text-gray-600">
            {user.email && (
              <div className="flex items-center gap-2 pr-4 border-r-2 border-primary">
                <WebIcon icon="Text" size="small" />
                <span className="text-small text-lighterGrey">
                  {user.email}
                </span>
              </div>
            )}
            {user.phone && (
              <div className="flex items-center gap-2">
                <WebIcon icon="Call" size="small" />
                <span className="text-small text-lighterGrey">
                  {user.phone}
                </span>
              </div>
            )}
          </div>
        </div>
      </div>

      <ActionButtons onDelete={onDelete} onModify={onModify} />
    </div>
  );
};

UserProfileHeader.propTypes = {
  user: PropTypes.shape({
    avatar: PropTypes.string,
    name: PropTypes.string,
    role: PropTypes.string,
    party: PropTypes.string,
    email: PropTypes.string,
    phone: PropTypes.string,
  }),
  onDelete: PropTypes.func,
  onModify: PropTypes.func,
};

export default UserProfileHeader;
